import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getDialogConfig() {
    const CUSTOM_CONFIG = {
        Login: {
            lastLoginTime: {
                hide: false,
            },
        },
        LoginDialog: {
            usernamePasswordLogin: {
                register: {
                    hide: false,
                },
            },
        },
    };

    return {
        custom: {
            [PALETTE_IDS.DIALOGS]: CUSTOM_CONFIG,
        },
        palette: {
            [PALETTE_IDS.COMBINATION_ODDS_POPUP]: {
                COMBINATION_ODDS_HEADER_TITLE: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                COMBINATION_ODDS_TABLE: {
                    TABLE_HEADER_TEXT: COLOR.BRAND.FOREGROUND2,
                },
            },
            [PALETTE_IDS.DIALOGS]: {
                DIALOGS_CONTAINER_BORDER_RADIUS: 0,
            },
            [PALETTE_IDS.AUTO_CASHOUT_DIALOG]: {
                AC_BET_DATE_TEXT: COLOR.BRAND.FOREGROUND2,
                AC_DIALOG_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                AC_PENDING_MESSAGE_LABEL_TEXT: COLOR.BRAND.FOREGROUND6,
                AC_INPUT: {
                    INPUT_DISABLED_BORDER_COLOR: COLOR.BRAND.FOREGROUND7,
                },
            },
            [PALETTE_IDS.LOGIN_DIALOG]: {
                LOGIN_DIALOG_TITLE_TEXT: {
                    fontSize: FONT.SIZE_MEDIUM,
                    color: COLOR.RESERVED.BLACK,
                },
                LOGIN_DIALOG_INPUT: {
                    INPUT_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                    INPUT_TEXT: COLOR.RESERVED.BLACK,
                },
                LOGIN_DIALOG_FORGOT_DETAILS_TEXT: {
                    fontSize: FONT.SIZE_SMALL,
                    color: COLOR.BRAND.ACCENT2,
                },
                LOGIN_DIALOG_REGISTER_INVITATION_TEXT: {
                    fontSize: FONT.SIZE_MEDIUM,
                    color: COLOR.BRAND.FOREGROUND6,
                },
                CHANGE_PASSWORD_CONTAINER_TEXT: {
                    fontSize: '11px',
                    color: COLOR.RESERVED.BLACK,
                },
                CHANGE_PASSWORD_POLICIES_TEXT: COLOR.BRAND.BACKGROUND6,
            },
            [PALETTE_IDS.ALERT_DIALOG]: {
                ALERT_DIALOG_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                ALERT_DIALOG_MESSAGE_TEXT: COLOR.BRAND.FOREGROUND1,
            },
        },
    };
}
